(function () {
  function initBuyBox(root) {
    var dataNode = root.querySelector('[data-v24-variants]');
    if (!dataNode) return;

    var variants;
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch (error) {
      console.error('Unable to load the V24 buy box data.', error);
      return;
    }

    var state = {
      size: root.getAttribute('data-default-size') || 'Medium',
      plan: 'starter'
    };
    var currency = root.getAttribute('data-currency') || 'USD';
    var locale = document.documentElement.lang || 'en-US';
    var sizeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-v24-size]'));
    var planButtons = Array.prototype.slice.call(root.querySelectorAll('[data-v24-plan]'));
    var addButton = root.querySelector('[data-v24-add]');
    var onceButton = root.querySelector('[data-v24-once]');
    var message = root.querySelector('[data-v24-message]');
    var selectedOffer = null;

    function money(cents) {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(cents / 100);
      } catch (error) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function normalize(value) {
      return String(value || '').trim().toLowerCase();
    }

    function findVariant(jarCount) {
      var exact = variants.find(function (variant) {
        return variant.available && normalize(variant.dogSize) === normalize(state.size) && variant.jarCount === jarCount;
      });
      if (exact) return exact;

      return variants.find(function (variant) {
        return variant.available && normalize(variant.dogSize) === normalize(state.size);
      }) || variants.find(function (variant) { return variant.available; });
    }

    var offerMap = {
      toy: {
        starter: { jars: 1, days: 90, interval: 'Ships every 3 months', planTerms: ['3 month', '90 day'] },
        trial: null
      },
      small: {
        starter: { jars: 2, days: 120, interval: 'Ships every 4 months', planTerms: ['4 month', '120 day'] },
        trial: { jars: 1, days: 60, interval: 'Ships every 2 months', planTerms: ['2 month', '60 day'] }
      },
      medium: {
        starter: { jars: 3, days: 120, interval: 'Ships every 120 days', planTerms: ['120 day', '4 month'] },
        trial: { jars: 1, days: 40, interval: 'Ships every 40 days', planTerms: ['40 day'] }
      },
      large: {
        starter: { jars: 3, days: 90, interval: 'Ships every 3 months', planTerms: ['3 month', '90 day'] },
        trial: { jars: 1, days: 30, interval: 'Ships every month', planTerms: ['1 month', '30 day', 'monthly'] }
      }
    };

    function currentSizeOffers() {
      return offerMap[normalize(state.size)] || offerMap.medium;
    }

    function findAllocation(variant, planTerms) {
      if (!variant || !variant.plans || !variant.plans.length) return null;
      return variant.plans.find(function (plan) {
        var name = normalize(plan.name);
        return planTerms.some(function (term) { return name.indexOf(term) !== -1; });
      }) || null;
    }

    function baseJarPrice() {
      var oneJar = findVariant(1);
      return oneJar ? oneJar.price : 0;
    }

    function offerFor(planName) {
      var spec = currentSizeOffers()[planName];
      if (!spec) return null;
      var variant = findVariant(spec.jars);
      var allocation = findAllocation(variant, spec.planTerms);
      var price = allocation ? allocation.price : (variant ? variant.price : 0);
      var compare = baseJarPrice() * spec.jars;
      if (!compare && variant) compare = variant.compareAtPrice || variant.price;
      var discount = compare > price ? Math.round((compare - price) * 100 / compare) : 0;

      return {
        allocation: allocation,
        compare: compare,
        days: spec.days,
        discount: discount,
        interval: spec.interval,
        jars: spec.jars,
        price: price,
        variant: variant
      };
    }

    function updatePlan(button, offer) {
      if (!button || !offer || !offer.variant) return;
      var daily = offer.price / offer.days;
      var compareDaily = offer.compare / offer.days;
      var dailyNode = button.querySelector('[data-v24-daily]');
      var compareDailyNode = button.querySelector('[data-v24-daily-compare]');
      var discountNode = button.querySelector('[data-v24-discount]');
      var titleNode = button.querySelector('[data-v24-title]');
      var metaNode = button.querySelector('[data-v24-meta]');
      if (titleNode) titleNode.textContent = '90-day starter routine';
      if (metaNode) {
        metaNode.textContent = offer.jars + (offer.jars === 1 ? ' jar · ' : ' jars · ') + offer.interval;
        if (button.getAttribute('data-v24-plan') === 'trial') metaNode.textContent = offer.interval + ' · Shorter trial';
      }
      if (dailyNode) dailyNode.textContent = money(daily);
      if (compareDailyNode) compareDailyNode.textContent = money(compareDaily);
      if (discountNode) discountNode.textContent = offer.discount + '% OFF';
    }

    function render() {
      var availableOffers = currentSizeOffers();
      var trialButton = root.querySelector('[data-v24-plan="trial"]');
      if (trialButton) trialButton.hidden = !availableOffers.trial;
      if (!availableOffers[state.plan]) state.plan = 'starter';

      sizeButtons.forEach(function (button) {
        var active = normalize(button.getAttribute('data-v24-size')) === normalize(state.size);
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      planButtons.forEach(function (button) {
        var planName = button.getAttribute('data-v24-plan');
        var active = planName === state.plan;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        var offer = offerFor(planName);
        if (offer) updatePlan(button, offer);
      });

      selectedOffer = offerFor(state.plan);
      if (!selectedOffer || !selectedOffer.variant) return;

      var image = root.querySelector('[data-v24-image]');
      var oneJarImage = findVariant(1);
      if (image && oneJarImage && oneJarImage.image) image.src = oneJarImage.image;

      var ctaPrice = root.querySelector('[data-v24-cta-price]');
      var ctaCompare = root.querySelector('[data-v24-cta-compare]');
      if (ctaPrice) ctaPrice.textContent = money(selectedOffer.price);
      if (ctaCompare) ctaCompare.textContent = money(selectedOffer.compare);
      var benefitDiscount = root.querySelector('[data-v24-benefit-discount]');
      if (benefitDiscount) benefitDiscount.textContent = selectedOffer.discount + '% off';

      var onceVariant = findVariant(1);
      var oncePrice = root.querySelector('[data-v24-once-price]');
      if (oncePrice && onceVariant) oncePrice.textContent = money(onceVariant.price);
      if (message) message.textContent = '';
      if (addButton) addButton.disabled = !selectedOffer.allocation;
      if (!selectedOffer.allocation && message) {
        message.textContent = 'This delivery schedule is not available in Shopify yet.';
      }
    }

    function addToCart(item, trigger) {
      if (!item || !item.id || trigger.dataset.v24Adding === 'true') return;
      var originalHtml = trigger.innerHTML;
      trigger.dataset.v24Adding = 'true';
      trigger.disabled = true;
      trigger.textContent = 'ADDING…';
      if (message) message.textContent = '';

      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Unable to add this item.'); });
          return response.json();
        })
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function (error) {
          if (message) message.textContent = error.message;
        })
        .finally(function () {
          delete trigger.dataset.v24Adding;
          trigger.innerHTML = originalHtml;
          trigger.disabled = trigger === addButton && (!selectedOffer || !selectedOffer.allocation);
        });
    }

    sizeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.size = button.getAttribute('data-v24-size');
        render();
      });
    });

    planButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.plan = button.getAttribute('data-v24-plan');
        render();
      });
    });

    if (addButton) {
      addButton.addEventListener('click', function () {
        if (!selectedOffer || !selectedOffer.variant) return;
        if (!selectedOffer.allocation) {
          if (message) message.textContent = 'This delivery schedule is not available in Shopify yet.';
          return;
        }
        var item = { id: selectedOffer.variant.id, quantity: 1 };
        item.selling_plan = selectedOffer.allocation.id;
        addToCart(item, addButton);
      });
    }

    if (onceButton) {
      onceButton.addEventListener('click', function (event) {
        event.preventDefault();
        var variant = findVariant(1);
        if (variant) addToCart({ id: variant.id, quantity: 1 }, onceButton);
      });
    }

    var guideButton = root.querySelector('[data-v24-guide]');
    var guide = root.querySelector('[data-v24-guide-panel]');
    if (guideButton && guide) {
      guideButton.addEventListener('click', function () {
        var expanded = guideButton.getAttribute('aria-expanded') === 'true';
        guideButton.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        guide.hidden = expanded;
      });
    }

    if (!sizeButtons.some(function (button) { return normalize(button.getAttribute('data-v24-size')) === normalize(state.size); })) {
      state.size = sizeButtons.length ? sizeButtons[0].getAttribute('data-v24-size') : state.size;
    }
    render();
  }

  function initAll() {
    document.querySelectorAll('[data-cwr-buybox-v24]').forEach(initBuyBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
